export default __webpack_public_path__ + "static/media/endorsment_welcome_image.802d634f.png";